<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/register.jpg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                  <h4><img src="@/assets/images/intro/intro_logo.png" alt="FilledU"/></h4> <br>

                <div class="vx-card__title mb-4">
                  <!-- <h4 class="mb-4">Login</h4> -->
                  <!-- <p>Welcome back, please login to your account.</p> -->
                  <h4 class="mb-4"><strong>로그인</strong></h4>
                  <p>환영합니다. 당신의 계정으로 로그인을 해주세요.</p>
                </div>

                <vs-tabs>
                  <vs-tab label="Login">
                    <login-jwt></login-jwt>
                  </vs-tab>

<!--
                  <vs-tab label="Firebase">
                    <login-firebase></login-firebase>
                  </vs-tab>

                  <vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab> -->
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from "./LoginJWT.vue"
// import LoginFirebase from "./LoginFirebase.vue"
// import LoginAuth0 from "./LoginAuth0.vue"


export default {
  components: {
    LoginJwt
    // LoginFirebase,
    // LoginAuth0
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
